import React from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';

const RouteSelectionPanel = ({ 
  routes, 
  selectedRoute, 
  onSelectRoute, 
  searchQuery, 
  onSearchChange,
  onNewGeometry 
}) => {
  const filteredRoutes = routes?.filter(route =>
    route?.route_name?.toLowerCase()?.includes(searchQuery?.toLowerCase())
  );

  const getGeometryStatus = (route) => {
    if (!route?.has_geometry) {
      return { label: 'Geometri Yok', color: 'text-muted-foreground', bgColor: 'bg-muted' };
    }
    if (route?.distance_meters > 0) {
      return { label: 'Tamamlandı', color: 'text-success', bgColor: 'bg-success/10' };
    }
    return { label: 'Eksik', color: 'text-warning', bgColor: 'bg-warning/10' };
  };

  return (
    <div className="flex flex-col h-full bg-card border-r border-border">
      <div className="p-4 md:p-6 border-b border-border space-y-4">
        <div className="flex items-center justify-between">
          <h2 className="text-lg md:text-xl font-bold text-foreground font-heading">
            Rota Listesi
          </h2>
          <Button
            variant="default"
            size="sm"
            iconName="Plus"
            iconPosition="left"
            onClick={onNewGeometry}
          >
            Yeni
          </Button>
        </div>

        <Input
          type="search"
          placeholder="Rota ara..."
          value={searchQuery}
          onChange={(e) => onSearchChange(e?.target?.value)}
          className="w-full"
        />

        <div className="flex items-center gap-2 text-xs text-muted-foreground">
          <Icon name="Info" size={14} color="var(--color-muted-foreground)" />
          <span>{filteredRoutes?.length} rota bulundu</span>
        </div>
      </div>
      <div className="flex-1 overflow-y-auto p-2 md:p-4">
        {filteredRoutes?.length === 0 ? (
          <div className="flex flex-col items-center justify-center h-full text-center p-4 md:p-8">
            <div className="flex items-center justify-center w-16 h-16 bg-muted rounded-full mb-4">
              <Icon name="Search" size={32} color="var(--color-muted-foreground)" />
            </div>
            <p className="text-sm text-muted-foreground">Rota bulunamadı</p>
          </div>
        ) : (
          <div className="space-y-2">
            {filteredRoutes?.map((route) => {
              const status = getGeometryStatus(route);
              const isSelected = selectedRoute?.id === route?.id;

              return (
                <button
                  key={route?.id}
                  onClick={() => onSelectRoute(route)}
                  className={`w-full text-left p-3 md:p-4 rounded-lg border transition-smooth hover-lift ${
                    isSelected
                      ? 'border-primary bg-primary/5' :'border-border bg-card hover:bg-muted/50'
                  }`}
                >
                  <div className="flex items-start justify-between gap-3 mb-2">
                    <h3 className="text-sm md:text-base font-semibold text-foreground line-clamp-1">
                      {route?.route_name}
                    </h3>
                    <span className={`flex-shrink-0 px-2 py-1 rounded text-xs font-medium ${status?.color} ${status?.bgColor}`}>
                      {status?.label}
                    </span>
                  </div>
                  <div className="space-y-1">
                    <div className="flex items-center gap-2 text-xs text-muted-foreground">
                      <Icon name="MapPin" size={12} color="var(--color-muted-foreground)" />
                      <span className="line-clamp-1">{route?.start_point}</span>
                    </div>
                    <div className="flex items-center gap-2 text-xs text-muted-foreground">
                      <Icon name="MapPin" size={12} color="var(--color-muted-foreground)" />
                      <span className="line-clamp-1">{route?.end_point}</span>
                    </div>
                    {route?.distance_meters > 0 && (
                      <div className="flex items-center gap-2 text-xs text-muted-foreground">
                        <Icon name="Ruler" size={12} color="var(--color-muted-foreground)" />
                        <span>{(route?.distance_meters / 1000)?.toFixed(2)} km</span>
                      </div>
                    )}
                  </div>
                </button>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export default RouteSelectionPanel;